import { Box } from 'braid-design-system';

import { Animate } from '../Animate/Animate';
import { ProfileCardShell } from '../Profile/ProfileCard/ProfileCardShell';
import { Shimmer } from '../Shimmer/Shimmer';

export const SkeletonLoader = ({
  isLoading,
  children,
}: {
  isLoading: boolean;
  children: React.ReactNode;
}) => (
  <Animate animateOn={isLoading} transition="fade">
    <Animate.WhenTrue>
      <Box background="body" borderRadius={['none', 'large']}>
        <Box paddingX="medium" alignItems="center" paddingTop="medium">
          <Shimmer.Text width="large" />
        </Box>
        {[...Array(4)].map((_, index) => (
          <Box key={index} paddingX="medium" paddingY="medium">
            <ProfileCardShell />
          </Box>
        ))}
      </Box>
    </Animate.WhenTrue>

    <Animate.WhenFalse>{children}</Animate.WhenFalse>
  </Animate>
);
